/* AFIQ collection pages (port of site/collection.js). Loaded (deferred) by every afiq-collection-* section;
   the guard below makes it run once. Each part bails if its root element is missing.
   - hero deck art, gift-guide art + live prices, ladder strip (AFIQ.LADDER)
   - grid: re-renders the server cards (bundle SKUs → set cards priced by AFIQ_UI.priceDecks, AFIQ decks →
     AFIQ_UI.deckCard), full-system promo tile, client-side filter chips + sort.
   Prices always come from priceDecks (the cheapest real checkout route), never hard-coded. */
(function () {
  'use strict';
  if (window.__afiqCollection) return;
  window.__afiqCollection = true;
  if (!window.AFIQ_UI || !window.AFIQ) return;
  var U = window.AFIQ_UI, P = U.P, $ = U.$, esc = U.esc, I = U.I, priceDecks = U.priceDecks, stack = U.stack;
  var has = function (id) { return !!P[id]; };
  var ids = function (s) { return String(s || '').split(',').map(function (x) { return x.trim(); }).filter(has); };
  var byHandle = {};
  Object.keys(P).forEach(function (id) { byHandle[P[id].handle] = id; });

  /* ---------- hero art ---------- */
  function hero(root) {
    root.querySelectorAll('.ph-art[data-art]').forEach(function (el) {
      el.innerHTML = ids(el.dataset.art).map(function (d, i) { return '<img src="' + esc(P[d].cutout) + '" alt="" style="--i:' + i + '">'; }).join('');
    });
  }

  /* ---------- gift guide ---------- */
  function guide(root) {
    root.querySelectorAll('[data-afiq-coll-guide] .gg').forEach(function (a) {
      var t = a.dataset.target, st = a.querySelector('.mini-stack[data-decks]'), pr = a.querySelector('[data-gg-price]');
      if (st) { var d = ids(st.dataset.decks); if (d.length) st.outerHTML = stack(d); }
      if ((t === 'fl5' || t === 'basics') && has(t)) a.href = P[t].url;
      if (t === 'elite') a.href = U.bundleUrl('elite');
      if (!pr) return;
      if (t === 'elite' && U.VOLS.length === 4) pr.textContent = $(priceDecks(['v1', 'v2', 'v3', 'v4']).total);
      else if ((t === 'fl5' || t === 'basics') && has(t)) pr.textContent = $(P[t].price);
      else if (t === 'team') pr.textContent = $(AFIQ.unitCents(10)) + ' a deck';
    });
  }

  /* ---------- ladder strip ---------- */
  function ladder(root) {
    root.querySelectorAll('[data-lstrip]').forEach(function (el) {
      el.innerHTML = '<div><b>1</b><span>deck</span><em>' + $(AFIQ.DECK_CENTS) + '</em></div>' +
        AFIQ.LADDER.map(function (t) {
          return '<div class="' + (t.min === 4 ? 'hl' : '') + '"><b>' + t.min + (t.min >= 10 ? '+' : t.min === 4 ? '–9' : '') + '</b><span>decks · ' + t.pct + '% off</span><em>' + $(AFIQ.unitCents(t.min)) + ' each</em></div>';
        }).join('');
    });
  }

  /* ---------- grid ---------- */
  var SETS = {
    elite: { title: 'The full system', sub: 'Volumes 1–4 · 216 cards', badge: 'Most popular' },
    core: { title: 'Vol 1–3 set', sub: 'Coverages, the trenches and the QB room' },
    starter: { title: 'Play Fast bundle', sub: 'Volumes 1–2 · 108 cards' }
  };
  function setCard(it) {
    var s = SETS[it.set] || { title: it.el.querySelector('b').textContent, sub: '' }, q = priceDecks(it.decks);
    /* No badge on the smaller sets (merchandising rule): only Elite carries one. */
    return '<a class="dk setk" href="' + esc(it.el.getAttribute('href')) + '">' + (s.badge ? '<span class="dk-b alt">' + s.badge + '</span>' : '') +
      '<div class="dk-img">' + stack(it.decks) + '</div>' +
      '<div class="dk-t"><span class="dk-k">Set · ' + it.decks.length + ' decks</span><b>' + esc(s.title) + '</b>' +
      '<span class="dk-r">' + esc(s.sub) + '</span>' +
      '<span class="dk-p">' + $(q.total) + (q.save > 0 ? '<s>' + $(q.full) + '</s><span class="dk-save">Save ' + $(q.save) + '</span>' : '') + '</span></div></a>';
  }
  function promo() {
    var e = priceDecks(['v1', 'v2', 'v3', 'v4']);
    return '<div class="promo"><div><span class="eyebrow" style="color:#fff">Most popular</span><b>All four volumes. ' + $(e.total) + '.</b></div>' +
      '<p>The full system: 216 cards, from terms and coverages to the QB room and the perimeter. Save ' + $(e.save) + ', and add Flag 5v5 or Basics on the same page.</p>' +
      '<a class="btn" href="' + esc(U.bundleUrl('elite')) + '">See the full system</a></div>';
  }
  function grid(root) {
    var sec = root.matches && root.matches('[data-afiq-coll]') ? root : root.querySelector('[data-afiq-coll]');
    if (!sec) return;
    var g = sec.querySelector('[data-grid]'), countEl = sec.querySelector('[data-count]'), chips = sec.querySelector('[data-chips]'), sortEl = sec.querySelector('[data-sort]');
    if (!g) return;
    var coll = sec.dataset.collection || '', showPromo = sec.hasAttribute('data-promo');
    var items = [].slice.call(g.children).filter(function (el) { return el.matches('a.dk'); }).map(function (el, n) {
      var it = { el: el, n: n, rank: +el.dataset.rank || 999, price: +el.dataset.price || 0, reviews: +el.dataset.reviews || 0, kind: el.dataset.kind, id: byHandle[el.dataset.handle], decks: [] };
      if (it.kind === 'set') {
        it.set = el.dataset.set; it.decks = ids(el.dataset.decks);
        if (it.decks.length && it.decks.length === String(el.dataset.decks).split(',').length) { it.html = setCard(it); it.price = priceDecks(it.decks).total; }
      } else if (it.id) {
        it.kind = 'deck';
        var tmp = document.createElement('div'); tmp.innerHTML = U.deckCard(it.id);
        /* Single volumes stay listed but untagged (no push on singles). */
        if (P[it.id].kind === 'volume') tmp.querySelectorAll('.dk-b').forEach(function (b) { b.remove(); });
        it.html = tmp.innerHTML; it.price = P[it.id].price; it.reviews = (P[it.id].reviews || { count: 0 }).count;
      }
      if (!it.html) it.html = el.outerHTML;
      return it;
    });
    items.sort(function (a, b) { return a.rank - b.rank || a.n - b.n; });

    var filter = 'all', sort = 'featured';
    var match = function (it, f) {
      if (f === 'all') return true;
      if (f === 'sets') return it.kind === 'set';
      if (f === 'digital') return it.kind === 'digital';
      return it.id === f || (it.kind === 'set' && it.decks.indexOf(f) > -1);
    };
    function render() {
      var list = items.filter(function (it) { return match(it, filter); });
      if (sort === 'low') list = list.slice().sort(function (a, b) { return a.price - b.price; });
      if (sort === 'high') list = list.slice().sort(function (a, b) { return b.price - a.price; });
      if (sort === 'reviews') list = list.slice().sort(function (a, b) { return b.reviews - a.reviews; });
      var cards = list.map(function (it) { return it.html; });
      if (showPromo && filter === 'all' && sort === 'featured' && U.VOLS.length === 4) cards.splice(Math.min(3, cards.length), 0, promo());
      g.innerHTML = cards.join('');
      if (countEl) countEl.textContent = list.length + ' product' + (list.length === 1 ? '' : 's');
      if (chips) chips.querySelectorAll('button').forEach(function (b) { var on = b.dataset.f === filter; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
    }
    if (chips) {
      /* Hide chips that would show nothing in this collection. */
      chips.querySelectorAll('button').forEach(function (b) { if (b.dataset.f !== 'all' && !items.some(function (it) { return match(it, b.dataset.f); })) b.hidden = true; });
      chips.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b || b.dataset.f === filter) return;
        filter = b.dataset.f; render();
        U.track('afiq_collection_filter', { collection: coll, filter: filter, sort: sort });
      });
    }
    if (sortEl) sortEl.addEventListener('change', function () {
      sort = sortEl.value; render();
      U.track('afiq_collection_filter', { collection: coll, filter: filter, sort: sort });
    });
    render();
  }

  function init(root) { hero(root); guide(root); ladder(root); grid(root); }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
